<template>
<b-container>
  <b-row>
    <b-col sm="12" md="12" lg="12" class="d-block">
      <p class="d-block"></p>
      <h5><b>{{course.title}}</b></h5>
    </b-col>
    <b-col sm="12" md="12" lg="6" class="d-block">
      <p class="d-sm-line">
        <b>Dates:</b>
        {{course.beginDate}} - {{course.endDate}}
      </p>
    </b-col>
    <b-col sm="12" md="12" lg="6" class="d-block">
      <p>
        <b
          v-b-tooltip.hover
          v-b-tooltip.html
          title="<ul class='list-group text-left'><li>M - Monday</li><li>T - Tuesday</li><li>W - Wednesday</li><li>R - Thursday</li><li>F - Friday</li><li>S - Saturday</li><li>U - Sunday</li></ul>"
        >
          Meets
          <b-icon-info></b-icon-info>:
        </b>
        {{course.daysOfWeek}}
      </p>
    </b-col>
    <b-col sm="12" md="12" lg="6" class="d-block">
      <p>
        <b>Credits:</b>
        {{course.creditHours}}
      </p>
    </b-col>
    <b-col sm="12" md="12" lg="6" class="d-block">
      <p>
        <b>Seats Available:</b>
        {{course.seats}}
      </p>
    </b-col>
    <b-col sm="12" md="12" lg="6" class="d-block">
      <p>
        <b>Cost:</b>
        ${{course.cost}}
      </p>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
  name: "Course",
  props: {
    course: {}
  }
};
</script>

<style scoped>
p {
  margin-bottom: 0.5rem;
  margin-left: 1.5rem;
  }
h5 {
  margin-left: 1rem;
}
.CourseResults { width: 100%;}
</style>
